import {Mapper} from '@s-ui/domain'

const getBreadcrumb = ({text, url} = {}) => ({
  label: text,
  url
})

export default class FromPageNameToAdsListBreadcrumbVOMapper extends Mapper {
  constructor({config, valueObject}) {
    super()

    this._config = config
    this._valueObject = valueObject
  }

  map = ({
    bodyType = {},
    category2 = {},
    city = {},
    colour = {},
    cubicCapacity = {},
    fuelType = {},
    make = {},
    model = {},
    priceRangeGroup = {},
    province = {},
    seatingCapacity = {},
    section: category1 = {},
    section2 = {},
    sellerType = {},
    transmissionType = {},
    version = {},
    year = {}
  }) => {
    const SITE_NAME = this._config.get('TENANT')
    const breadcrumbs = [
      category1.text && getBreadcrumb(category1),
      section2.text && getBreadcrumb(section2),
      make.text && getBreadcrumb(make),
      model.text && getBreadcrumb(model),
      version.text && getBreadcrumb(version),
      fuelType.text && getBreadcrumb(fuelType),
      bodyType.text && getBreadcrumb(bodyType),
      province.text && getBreadcrumb(province),
      city.text && getBreadcrumb(city),
      sellerType.text && getBreadcrumb(sellerType),
      seatingCapacity.text && getBreadcrumb(seatingCapacity),
      transmissionType.text && getBreadcrumb(transmissionType),
      year.text && getBreadcrumb(year),
      priceRangeGroup.text && getBreadcrumb(priceRangeGroup),
      category2.text && getBreadcrumb(category2),
      cubicCapacity.text && getBreadcrumb(cubicCapacity),
      colour.text && getBreadcrumb(colour),
      {
        label: 'COMMON_SEARCH_ENGINE',
        params: {siteName: SITE_NAME.toLowerCase()}
      }
    ].filter(Boolean)
    return this._valueObject({breadcrumbs})
  }
}
